import { create } from 'zustand'

import type { Order } from '../types/order.type'

export type OrderSearchStoreState = {
  orders: Order[]
  filters: {
    dataInicio?: string
    dataFim?: string
    codigo?: string
    cliente?: string
    status?: string
    cnpjcpf?: string
  }
}

export type OrderSearchStoreAction = {
  actions: {
    setOrders: (orders: Order[]) => void
    setFilters: (filters: {
      dataInicio?: string
      dataFim?: string
      codigo?: string
      cliente?: string
      status?: string
      cnpjcpf?: string
    }) => void
  }
}

export const useOrdersSearchStore = create<
  OrderSearchStoreAction & OrderSearchStoreState
>((set) => ({
  orders: [],
  filters: {
    dataInicio: undefined,
    dataFim: undefined,
    codigo: undefined,
    cliente: undefined,
    status: undefined,
    cnpjcpf: undefined
  },

  actions: {
    setOrders: (orders) => set({ orders }),
    setFilters: (filters) => set({ filters: { ...filters } }),
  },
}))